var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.141,
    height: 28.923,
    viewBox: "0 0 30.141 28.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185.777 -146.266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.749 153.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.157,96H111.04a1.157,1.157,0,0,1,0,2.314H97.157a1.157,1.157,0,1,1,0-2.314Z",
    transform: "translate(-96 -96)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(197.385 157.835)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.157,160h9.255a1.157,1.157,0,0,1,0,2.314H97.157a1.157,1.157,0,0,1,0-2.314Z",
    transform: "translate(-96 -160)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.777 146.266)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.637,0H25.5a4.637,4.637,0,0,1,4.637,4.628V27.766a1.156,1.156,0,0,1-.668,1.048,1.178,1.178,0,0,1-.492.109,1.16,1.16,0,0,1-.742-.268l-6.633-5.516H4.637A4.637,4.637,0,0,1,0,18.511V4.628A4.637,4.637,0,0,1,4.637,0ZM2.319,18.511a2.319,2.319,0,0,0,2.319,2.314H22.026a1.159,1.159,0,0,1,.742.268l5.054,4.2V4.628A2.319,2.319,0,0,0,25.5,2.314H4.637A2.319,2.319,0,0,0,2.319,4.628Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalConversationIcon);
export default __webpack_public_path__ + "static/media/digital-conversation-icon.baa1b010f82bed1338768b2a6c344cb6.svg";
export { ForwardRef as ReactComponent };